import graphql__42895cdab495277bf77b from "./__generated__/PageSectionCalendar_pageSection.graphql.js";import { graphql, useFragment } from "react-relay";

import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import ContainerWithSidebar from "../Sidebar/ContainerWithSidebar";
import Calendar from "../Calendar/Calendar";

const PageSectionCalendar = props => {
  const pageSection = useFragment(PageSectionCalendar_pageSection, props.pageSection);

  const { title, description, columnsRatio, columnsOrder, sidebar } = pageSection;

  return (
    <div className="container page-section page-section-calendar">
      <ContainerWithSidebar {...{ sidebar, columnsRatio, columnsOrder }}>
        <PageSectionBlockWithTitleAndDescription
          title={title}
          description={description}
          iconClassName="icon-calendar"
        >
          <div className="calendar-section-container">
            <Calendar section={pageSection} />
          </div>
        </PageSectionBlockWithTitleAndDescription>
      </ContainerWithSidebar>
    </div>
  );
};

const PageSectionCalendar_pageSection = graphql__42895cdab495277bf77b;

export default PageSectionCalendar;
